import { useQuery, useQueryClient } from '@tanstack/react-query';
import { base44 } from '@/api/base44Client';

const USER_QUERY_KEY = ['currentUser'];

export function useUser() {
  const queryClient = useQueryClient();

  const { data: user, isLoading, error, refetch } = useQuery({
    queryKey: USER_QUERY_KEY,
    queryFn: () => base44.auth.me(),
    staleTime: 10 * 1000, // 10 seconds
    refetchInterval: 30 * 1000, // Auto-refresh every 30 seconds
    refetchOnWindowFocus: true,
    retry: 1,
  });

  // Also refresh the org-aware available-credits query so the global credit display
  // updates immediately after a generation (org credits live in a separate query,
  // keyed ['availableCredits', orgId], that a plain user refetch would not touch).
  const refetchUser = () => {
    queryClient.invalidateQueries({ queryKey: ['availableCredits'] });
    return refetch();
  };

  const invalidateUser = () => queryClient.invalidateQueries({ queryKey: USER_QUERY_KEY });

  return {
    user: user || null,
    isLoading,
    isAuthenticated: !!user && !error,
    error,
    refetchUser,
    invalidateUser,
  };
}